import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import GridBlock from "../../GridBlock";
import Tr from "../../../translations/Translations";
import SimpleSelect from "../../SimpleSelect";
import {makeStyles} from "@material-ui/core/styles";
import {Paper, TextField} from "@material-ui/core";
import querystring from "querystring";
import {setSearchObj} from "../../../libs/RouterPath";
import WorkableIconButton from "../../button/WorkableIconButton";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "../../button/IconButton";
import CorrespondenceService from "services/CorrespondenceService";
import FlagRoundedIcon from "@material-ui/icons/FlagRounded";
import OutlinedFlagRoundedIcon from "@material-ui/icons/OutlinedFlagRounded";
import BoldTypography from "../../BoldTypography";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import DateFormats from "constants/DateFormats";
import moment, {isMoment} from "libs/moment";

const useStyle = makeStyles(theme => ({
    root: {

        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(2),
        }
    },
    search: {
        width: 170,
    },
    date: {
        width: 190,
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    },
    paper: {
        padding: theme.spacing(3)
    },
    flag: {
        color: theme.palette.error.main
    }
}));

const EMPTY_SEARCH_OBJECT = {subject: '', content: '', supplier: '', flag: '', dateFrom: null, dateTo: null}
const MAX_SEARCH_LENGTH = 100;

function CorrespondenceSearch(
    {
        searchInProgress,
        doSearch,
        contractor,
        rfxRoundId
    }) {


    const getInitValue = () => {
        const search = window.location.search.slice(1);
        const parsed = querystring.parse(search);
        const parsedFiltered = Object.keys(parsed)
            .filter((k) => EMPTY_SEARCH_OBJECT.hasOwnProperty(k))
            .reduce((a, k) => {
                const n = {...a};
                if(k === 'dateFrom' || k === 'dateTo') {
                    let dat = moment(parsed[k], DateFormats.DATETIME_FORMAT);
                    if(dat.isValid())
                        n[k] = dat;
                } else {
                    n[k] = parsed[k].substring(0, MAX_SEARCH_LENGTH)
                }
                return n;
            }, {})

        return {...EMPTY_SEARCH_OBJECT, ...parsedFiltered};
    }

    const classes = useStyle();
    const [value, setValue] = useState(getInitValue());
    const [contractorListForSelect, setContractorListForSelect] = useState([{label: Tr('any'), value: ''}]);
    const [submitState, setSubmitState] = useState(0);

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => !!value[k])
                .reduce((a, k) => ({...a, [k]: isMoment(value[k]) ? (value[k].isValid() ? value[k].format(DateFormats.DATETIME_FORMAT) : null) : value[k]}), {});

            const valueFilteredForSearch = Object.keys(value)
                .filter((k) => !!value[k])
                .reduce((a, k) => ({...a, [k]: isMoment(value[k]) ? (value[k].isValid() ? value[k].format() : null) : value[k]}), {});


            setSearchObj(valueFiltered);
            doSearch(valueFilteredForSearch);
        }
        // eslint-disable-next-line
    }, [submitState]);

    const prepareContractorList = (respList) => {
        setContractorListForSelect(x => [...x, ...respList.map(x => ({label: x.name, value: x.contractorDepartmentId.toString()}))]);
    }
    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleChangeDate = (id, date) => {
        const dateValue = date ? date: null;
        setValue({...value, [id]: dateValue})
    };

    const handleSubmit = () => {
        setSubmitState(x => x + 1)
    };


    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    useEffect(() => {
        if (!contractor) {
            CorrespondenceService.getBuyerContractorInRoundList(rfxRoundId).then(prepareContractorList);
        }

    }, [rfxRoundId, contractor]);

    return (
        <Paper className={classes.paper}>
            <BoldTypography>{Tr('search_box')}</BoldTypography>
            <GridBlock className={classes.root}>

                <IconButton className={classes.flag} Icon={value.flag === 'true' ? FlagRoundedIcon : OutlinedFlagRoundedIcon}
                            tooltip={value.flag === 'true' ? Tr('unflag') : Tr('flag_threads')} onClick={() => {
                    const newFlag = value.flag === 'true' ? '' : 'true';
                    handleChange('flag', {target: {value: newFlag}});
                    handleSubmit();
                }}/>

                <TextField
                    className={classes.search}
                    label={Tr('search_subject')}
                    onChange={e => handleChange('subject', e)}
                    onKeyUp={handleKeyUp}
                    fullWidth
                    value={value.subject}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                    // InputProps={{
                    //     endAdornment: <InputAdornment position="end">
                    //         <IconSearchButton disabled={searchInProgress}
                    //             onClick={handleSubmit}
                    //         />
                    //     </InputAdornment>,
                    // }}
                />

                <TextField
                    className={classes.search}
                    label={Tr('search_content')}
                    onChange={e => handleChange('content', e)}
                    onKeyUp={handleKeyUp}
                    fullWidth
                    value={value.content}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                    // InputProps={{
                    //     endAdornment: <InputAdornment position="end">
                    //         <IconSearchButton disabled={searchInProgress}
                    //             onClick={handleSubmit}
                    //         />
                    //     </InputAdornment>,
                    // }}
                />
                {!contractor &&
                <SimpleSelect
                    label={Tr('contractor')}
                    className={classes.search}
                    items={contractorListForSelect}
                    value={value.supplier}
                    onChange={(e) => {
                        handleChange('supplier', e);
                        handleSubmit();
                    }}
                />
                }


                <KeyboardDateTimePicker
                    className={classes.date}
                    label={Tr('date_from')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={value.dateFrom}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => handleChangeDate('dateFrom', e)}
                />

                <KeyboardDateTimePicker
                    className={classes.date}
                    label={Tr('date_to')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={value.dateTo}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => handleChangeDate('dateTo', e)}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={() => {
                        setValue(EMPTY_SEARCH_OBJECT);
                        handleSubmit()
                    }}/>
                </div>
            </GridBlock>
        </Paper>
    )
}

CorrespondenceSearch.propTypes = {
    classes: PropTypes.any,
}


export default CorrespondenceSearch;